module.exports = __webpack_public_path__ + "img/serviceBack.13ab57db.jpg";